module.exports = __webpack_public_path__ + "static/media/librarian.1df03f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/sliderPuzzle/librarian.png
// module id = 524
// module chunks = 0